import { IKeyboardShortcutHandler } from '@/components/chat/_domain/modules/keyboard-shortcut-service/keyboard-shortcut-service-interface';
import { SweetAlertOptions } from 'sweetalert2';
import html from './open-keyboard-shortcut-overlay-markup.html';
import { ISweetAlertService } from '@/app-modules/sweet-alert-service';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';


class KeyboardShortcutHandlerOpenOverlay implements IKeyboardShortcutHandler {
  public canProcessKeyboardEvent(keyboardEvent: KeyboardEvent): boolean {
    return keyboardEvent.ctrlKey && (keyboardEvent.key === '/' || keyboardEvent.key === '\'');
  }

  public processKeyboardEvent(keyboardEvent: KeyboardEvent): void {
    if (this.canProcessKeyboardEvent(keyboardEvent)) {
      const swalOptions = this.getSweetAlertOptions();
      this.sweetAlertService.show(swalOptions);
    }
  }

  private getSweetAlertOptions(): SweetAlertOptions {
    return {
      title: 'Keyboard Shortcuts',
      html: `${html}`,
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: 'Close',
      allowOutsideClick: false
    };
  }

  private get sweetAlertService(): ISweetAlertService {
    return container.get(SERVICE_IDENTIFIERS.ISweetAlertService);
  }
}

export { KeyboardShortcutHandlerOpenOverlay };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/keyboard-shortcut-service/handlers/open-keyboard-shortcut-overlay.ts